import * as moment from 'moment';
import * as React from 'react';
import { connect } from 'react-redux';
import LoadingSpinner from 'src/components/utils/LoadingSpinner/LoadinSpinner';
import { IconPaths } from 'src/icons';
import { ApplicationState } from 'src/store';
import { getEventsDaily } from 'src/store/events/actions';
import { User } from 'src/store/user/types';
import { colorSecondary } from 'src/variables';
import EventsDailyItem from './EventsDailyItem/EventsDailyItem';

interface Props {
  eventsById: any;
  allEvents: any;
  pending: boolean;
  getEventsDaily: typeof getEventsDaily;
  user: User;
}

interface State {
  offset: number;
  controls: {
    next: boolean;
    prev: boolean;
  };
}

class EventsDaily extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      offset: 2,
      controls: {
        next: true,
        prev: true
      }
    };
  }

  componentDidMount() {
    this.getEvents();
    this.checkControls(this.state.offset, -1);
  }

  getEvents = () => {
    this.props.getEventsDaily(moment().add(this.state.offset, 'd'));
  };

  onNext = (seeUpTo: number) => {
    const controls = this.checkControls(this.state.offset + 1, seeUpTo);
    if (seeUpTo < 0 || this.state.offset + 1 <= seeUpTo) {
      this.setState({ offset: this.state.offset + 1, controls }, () => {
        this.getEvents();
      });
    }
  };

  checkControls = (offset: number, seeUpTo: number) => {
    const controls = {
      next: true,
      prev: true
    };
    if (offset <= 0) {
      controls.prev = false;
    }
    if (seeUpTo > 0 && offset >= seeUpTo) {
      controls.next = false;
    }
    return controls;
  };

  onPrev = (seeUpTo: number) => {
    const controls = this.checkControls(this.state.offset - 1, seeUpTo);
    if (this.state.offset - 1 >= 0) {
      this.setState({ offset: this.state.offset - 1, controls }, () => {
        this.getEvents();
      });
    }
  };

  public render() {
    const { pending, user } = this.props;
    return (
      <div className="container">
        <div className="row">
          <div className="col-6 noPadLeft">
            <h2
              style={{
                textTransform: 'uppercase',
                fontSize: '1.3rem',
                textAlign: 'left',
                margin: 0
              }}
            >
              Veranstaltungen
            </h2>
          </div>
          {user && (
            <div
              className="col-6 noPadRight"
              style={{
                textAlign: 'left',
                display: 'flex',
                alignItems: 'center',
                backgroundColor: colorSecondary
              }}
            >
              <button
                className="noStyle pointer"
                disabled={!this.state.controls.prev}
                onClick={this.onPrev.bind(this, user.role.seeUpTo)}
              >
                <img src={IconPaths['arrow-icon']} style={{ height: '20px' }} />
              </button>

              <span
                style={{
                  fontSize: '1.2rem',
                  fontWeight: 'bold',
                  lineHeight: 0,
                  padding: '0 10px',
                  width: '220px'
                }}
              >
                {moment()
                  .add(this.state.offset, 'd')
                  .format('dddd DD.MM.')}
              </span>
              <button
                className="noStyle pointer"
                disabled={!this.state.controls.next}
                onClick={this.onNext.bind(this, user.role.seeUpTo)}
              >
                <img
                  className={`pointer ${this.state.controls.next ? '' : 'disabled'}`}
                  src={IconPaths['arrow-icon']}
                  style={{ transform: 'rotate(180deg)', height: '20px' }}
                />
              </button>
            </div>
          )}
        </div>
        <div className="row">
          <LoadingSpinner pending={pending} />

          <ul style={{ width: '100%', position: 'relative' }}>
            {this.props.allEvents.map((i: number, counter: number) => {
              const event = this.props.eventsById[i];
              return <EventsDailyItem event={event} key={counter} />;
            })}
          </ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ events, auth }: ApplicationState) => ({
  eventsById: events.data.byId,
  allEvents: events.data.nextDay,
  pending: events.loading,
  user: auth.data
});

const mapDispatchToProps = (dispatch: any) => ({
  getEventsDaily: (day: moment.Moment) => dispatch(getEventsDaily(day))
});

export default connect(mapStateToProps, mapDispatchToProps)(EventsDaily);



// WEBPACK FOOTER //
// ./src/components/Event/EventsDaily/EventsDaily.tsx